import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getSignatures,
  createSignature,
  updateSignature,
  deleteSignature,
  uploadSignaturePhoto,
} from '../api/signatures';

export function useSignatures() {
  return useQuery({
    queryKey: ['signatures'],
    queryFn: getSignatures,
  });
}

export function useCreateSignature() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createSignature,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['signatures'] });
    },
  });
}

export function useUpdateSignature() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Parameters<typeof updateSignature>[1] }) =>
      updateSignature(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['signatures'] });
    },
  });
}

export function useDeleteSignature() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteSignature,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['signatures'] });
    },
  });
}

export function useUploadSignaturePhoto() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, file }: { id: string; file: File }) =>
      uploadSignaturePhoto(id, file),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['signatures'] });
    },
  });
}
